import * as React from "react"

export const SpringOne = () => (
  <div className="hero-springone hero">
    <div className="container">
      <h1 className="has-text-weight-medium has-text-centered">
        <span>SpringOne</span>&nbsp;
        <span>at</span>&nbsp;
        <br />
        <span>Explore</span>&nbsp;
        <span>2025</span>&nbsp;
      </h1>
      <div className="springone-text">
        <p className="has-text-centered is-size-5">
          August 25-27, 2025 • Las Vegas, Nevada
        </p>
        <div className="py-4 has-text-centered">
          <a
            href="https://www.vmware.com/explore/us/springone"
            className="button is-spring-2 mr-3"
          >
            Learn more
          </a>
        </div>
      </div>
    </div>
  </div>
)
